module.exports = __webpack_public_path__ + "static/media/redCandle.1db21b40.png";